import React from "react";
import { Link } from "react-router-dom";
import styles from "./app-header.module.css"
import logout from '../../images/logout.svg';
import logo from '../../images/logo.png'

export default function AppHeader() {
    return (
        <header>
            <Link to="/">
                <img src={logo} height={62} />
            </Link>
            <div className={styles.user}>
                <div className={styles.userInfo}>
                    <div className={styles.userName}>Oleg Blohin</div>
                    <div className={styles.userRole}>CTO</div>
                </div>
                <img src={logout} height={42}></img>
            </div>
        </header>
    )
}